import { injectIntl } from 'react-intl';
import DatePicker from './DatePicker';

export default injectIntl(DatePicker);
